import { createGlobalStore } from "@wss/store";
type LoginModalOptions = {
  targetUrl?: string;
  queryParams?: string;
  callback?: () => void;
};
interface LoginModalState {
  modalOpen: boolean;
  options?: LoginModalOptions;
}
const loginModalStore = createGlobalStore<LoginModalState>(() => ({
  modalOpen: false
}));
const openLogin = (options?: LoginModalOptions) => loginModalStore.setState({
  modalOpen: true,
  options
});
const closeLogin = (): void => loginModalStore.setState({
  modalOpen: false,
  options: undefined
});
export default {
  openLogin,
  closeLogin,
  getState: loginModalStore.getState,
  useState: loginModalStore.useState
};